import { Certainty } from '@/shared/api/protocol-ts/model/dto_report_certainty_pb';
import { Decision } from '@/shared/api/protocol-ts/model/dto_report_common_pb';

export const isUserPositiveCertainty = (certainty?: Certainty): boolean =>
  certainty?.UserDecision === Decision.PositiveDecision ||
  (certainty?.UserScore !== undefined &&
    certainty?.UserDecision !== Decision.NegativeDecision);
